module.exports = __webpack_public_path__ + "img/img13.f42f7e91.jpg";